<div class="window" id="wincontainer" [ngStyle]="{ width: windowWidth }">
  <div class="video-container">
    <!-- video render here -->
    <div id="vimeo"></div>
    <!-- video render here -->
    <nav class="navbar navbar-mapsearch justify-content-between" id="map-navar" *ngIf="isMapsearchResult">
      <div class="map-item-1">
        <button (click)="onClickSearch()" class="back-to-map">
          <img src="{{ constants.Back_ARROW_IMG }}" alt="back" class="backToMap" />
          {{ constants.BACK_TO_MAP_TXT }}
        </button>
      </div>
      <div class="map-item-2">
        <div class="input-group search">
          <input type="text" class="form-control controls" placeholder="Search by Location"
            aria-label="Search by Country" id="pac-input" (input)="onSearch()" aria-describedby="basic-addon2"
            [(ngModel)]="Placesng" />
        </div>
      </div>
      <div class="map-item-3">
        <img class="map-navbar_close" (click)="onClickCloseMapSearch()" src="{{ constants.LOGIN_CLOSE_BUTTON }}"
          alt="Close" />
      </div>
    </nav>
    <!-- The section below is commented out because Publift ads need to be removed. -->
    <!-- <div class="ads-wrapper" *ngIf="!isPrime && !isMobile || !login && !isMobile">
      <div data-fuse="23174194657" id="window-vrec"></div>
    </div> -->
    <!-- boookmarknav -->
    <nav class="navbar navbar-bookmarkedWindow justify-content-between" id="map-navar"
      *ngIf="from === 'bookmarkedWindow'">
      <div class="bookmark-back" (click)="goTOBookmark()"><img class="bookmark-back-img"
          src="{{constants.BACK_BUTTON_BOOKMARK}}"></div>
      <div class="bookmarkedWindow-item-1">
        {{constants.MY_BOOKMARK_WINDOW_HEADING}}
        <!-- <app-user-menu *ngIf="from === 'bookmarkedWindow' && login" [from]="from"></app-user-menu> -->
        <img class="bookmarkedWindow-close-icon" (click)="onClickBackFromBookmark()"
          src="{{constants.BOOKMARK_CLOSE_BUTTON}}" alt="Close" />
      </div>
    </nav>
    <nav class="navbar navbar-light justify-content-between" id="nav-bar" [ngClass]="{
        'bg-transparent-1': isMapsearchResult || from === 'bookmarkedWindow',
        'bg-transparent': !isMapsearchResult || from === 'bookmarkedWindow',
        'bg-transparent-bookmarkedWindow': from === 'bookmarkedWindow'
      }">
      <div class="nav-item-1">
        <button (click)="onClickCloseMapSearch()" *ngIf="isMapsearchResult" class="map-back-mobile-button">
          {{ constants.BACK_TO_ALLVIDEOS
          }}<img src="{{ constants.LOGIN_CLOSE_BUTTON }}" />
        </button>
        <span>
          <div *ngIf="from === 'window' || isCampaign" id="author" class="author authorTwo" (click)="redirectUser()" [ngClass]="{'super':isSuperUser}">{{ author
            }}{{
            constants.AUTHOR_WINDOW_TXT }}
          </div>
        </span>
        <span *ngIf="from === 'bookmarkedWindow' && !isArtists" id="author" class="author" (click)="redirectUser()" [ngClass]="{'super':isSuperUser}">{{
          author }}{{
          constants.AUTHOR_WINDOW_TXT }}
        </span>
        <span *ngIf="from === 'bookmarkedWindow'||from === 'cityVideos'" id="author" class="author" (click)="redirectUser()" [ngClass]="{'super':isSuperUser}">{{
          author }}{{
          constants.AUTHOR_WINDOW_TXT }}
        </span>
      </div>
      <div class="say-thanks-div">
        <!-- *ngIf="receivePayment" -->
        <button *ngIf="receivePayment" class="say-thanks" placement="top" ngbTooltip="" (click)="OnclickSayThanks()">
          <img [src]="constants.tips_1_IMG" alt="" />
          {{ constants.SAY_THANKS }}
        </button>
      </div>
      <div class="nav-item-2">
        <a *ngIf="from === 'window'" routerLink="['/']" class="window-title">
          <h3 id="title-window">
            {{ constants.WINDOW_SWAP_TXT }}
          </h3>
        </a>
        <a *ngIf="isCampaign" href="http://courtneybarnett.com.au/" target="_blank" class="courtney-logo"><img
            src="{{ campaignConstants.LOGO_IMG }}" alt="" /></a>
        <a *ngIf="from === 'bookmarkedWindow' && !isArtists ||from === 'cityVideos'" routerLink="['/']"
          class="window-title">
          <h3 id="title-window">
            {{ constants.WINDOW_SWAP_TXT }}
          </h3>
        </a>
        <a *ngIf="isCampaign" routerLink="['/']" class="window-title">
          <h3 id="title-window"></h3>
        </a>
      </div>
      <div class="nav-item-3">

        <div class="campaign-location" *ngIf="videoItem?.locationImage && !isSwitchingWindow">
          <div class="d-flex justify-content-center align-items-center flex-row" (click)="trackCampaignClick($event)">
            <img class="camp-location loc-ping" *ngIf="videoItem?.locationImage && !isSwitchingWindow" rel="preload"
              [src]="constants.LOCATION_PING" />
            <img class="campaign-location-image" [src]="videoItem?.locationImage" alt="">
          </div>
          <button (click)="watchTrailerClick($event)" *ngIf="videoItem?.showTrailerButton" class="trailer-btn">Watch the trailer</button>
        </div>

        <div class="d-block"  [ngClass]="timeRecording !== '' && dateRecording !== '' ? 'm-t-50' : 'm-t-100 '">
          <a *ngIf="from === 'window' && login " id="location" href="http://maps.google.co.in/maps?q={{ location }}"
            target="_blank" class="location-sub-title" > <img class="mr-2 loc-ping" *ngIf="location" rel="preload" [src]="constants.LOCATION_PING" />{{ location }}</a>
          <h5 *ngIf="from === 'window' && login && timeRecording !== '' && dateRecording !== ''" id="date-time"
            target="_blank" class="recordedDateAndTime">{{timeRecording}}, {{dateRecording}} </h5>
        </div>

        <!-- <a *ngIf="from === 'window' && isPrime" id="location" (click)="toMapView()" class="location-sub-title">{{
          location }}</a> -->

        <app-user-menu *ngIf="from === 'window' && login" [dateRecording]="dateRecording"
          [timeRecording]="timeRecording" [isMapsearchResult]="isMapsearchResult" [from]="from">
        </app-user-menu>

        <div *ngIf="isCampaign" style="float: right">
          <!-- <a><img [src]="constants.PIN_IMG" alt="location-pin" class="location-icon" /></a> -->
          <div class="d-block">
            <a (click)="openWindowAlert('locationBeforeLogin')" id="location" class="location-title">{{ location
              }}</a>
            <!-- <h5 id="dateTime" *ngIf=" RecordedDateAndTime != ''" class="dateTime-sub-title ">{{
              RecordedDateAndTime}}</h5> -->

            <h5 *ngIf=" timeRecording !== '' && dateRecording !== ''" id="date-time" target="_blank"
              class="recordedDateAndTime">{{timeRecording}}, {{dateRecording}} </h5>
          </div>
        </div>
        <!-- <a *ngIf="from === 'window' && !login "><img [src]="constants.PIN_IMG" alt="location-pin"
            class="location-icon" /></a> -->
        <div class="d-block">
          <a *ngIf="from === 'window' && !login " (click)="openWindowAlert('locationBeforeLogin')" id="location"
            class="location-title"><img class="mr-2 loc-ping" *ngIf="location" rel="preload" [src]="constants.LOCATION_PING" />{{ location }}</a>
          <h5 *ngIf="from === 'window' && !login && timeRecording !== '' && dateRecording !== ''" id="date-time"
            target="_blank" class="recordedDateAndTimeNotLogin">{{timeRecording}}, {{dateRecording}} </h5>
        </div>
        <!-- <a *ngIf="from === 'window' && !login"><img [src]="constants.PIN_IMG" alt="location-pin"
              class="location-icon" /></a>

          <a *ngIf="from === 'window' && !login" (click)="openWindowAlert('locationBeforeLogin')" id="location"
            class="location-title">{{ location }}</a> -->
        <span *ngIf="from === 'bookmarkedWindow' && login" id="location">
          <!-- <a href="http://maps.google.co.in/maps?q={{ location }}" target="_blank"><img [src]="constants.PIN_IMG"
              alt="location-pin" class="location-icon" /></a> -->
          <a href="http://maps.google.co.in/maps?q={{ location }}" target="_blank" class="location-sub-title">{{
            location }}</a>
          <h5 *ngIf="from === 'bookmarkedWindow' && login && timeRecording !== '' && dateRecording !== ''" id="date-time"
            target="_blank" class="location-sub-title">{{timeRecording}}, {{dateRecording}} </h5>
          <!-- <a (mouseover)="onMouseOver()" (mouseout)="onMouseLeave()">
            <img class="profile-avatar" src="{{ profilePicture }}" />
          </a> -->
        </span>
        <span *ngIf="from === 'bookmarkedWindow' && !login ||from === 'cityVideos'" id="location"
          (click)="openWindowAlert('locationBeforeLogin')">
          <!-- <a style="pointer-events: none"><img [src]="constants.PIN_IMG" alt="location-pin" class="location-icon" /></a> -->
          <a style="pointer-events: none" class="location-sub-title">{{
            location
            }}</a>
    
          <h5 *ngIf="from === 'bookmarkedWindow' && !login && timeRecording !== '' && dateRecording !== ''"
            id="date-time" target="_blank" class="location-sub-title">{{timeRecording}}, {{dateRecording}} </h5>
        </span>
      </div>
    </nav>

    <!-- viator campain -->

    <div class="campaign-button">
      <div id="viator" class="localtext" [ngClass]="{
          'campaign-div-map': isMapsearchResult || from == 'bookmarkedWindow',
          'campaign-div': !isMapsearchResult
        }" *ngIf="showViatorLocal" (click)="blogClicked()">
        Read a local's guide<br />
        to {{ mixpanelPlace | titlecase }}
        <img src="{{ constants.VIATOR_IMG }}" class="viator-img" />
      </div>
      <a *ngIf="showViator" href="{{ blogUrl }}" target="_blank" (click)="viatorClicked()" class="book-now">
        Book now on
        <img src="{{ constants.VIATOR_IMG_NO_BG }}" class="viator-img-no-bg" />
      </a>
    </div>

    <div *ngIf="from === 'window'" [ngClass]="{
        'bookmark-alert-none': !showBookmarkAlert,
        'bookmark-alert': showBookmarkAlert
      }" id="bookmark-alert" (click)="showBookmarkAlert = false">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable alert-main">
        <div class="modal-content alert-content" id="alert-content">
          <div class="modal-body" *ngIf="alertSetter.afterSuccessPrime">
              <app-thanks-popup (onclickClose)="showBookmarkAlert = false"></app-thanks-popup>
          </div>
          <div class="modal-body alert-body" *ngIf="alertSetter.bookmarkLimitAert">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title-prime alert-popup-title-prime-2">
                {{ constants.BOOKMARK_LIMIT }}
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img-prime bookmark-alert-img-other" [src]="constants.BOOKMARK_ALERT_IMG"
                  alt="" />
              </div>
              <div class="new-div">
                <p class="alert-popup-content-prime-new">
                  {{ constants.GET_ALL_ACCESS_TXT }}
                </p>
                <p class="alert-popup-content-prime-new">
                  {{ constants.BOOKMARK_UPGRADE_NEW_BOOKMARK_LMIT }}
                </p>
              </div>
              <div class="new-div-1">
                <p class="alert-popup-content-prime-new">
                  {{ constants.GET_ALL_ACCESS_TXT }}
                </p>
                <p class="alert-popup-content-prime-new">
                  {{ constants.BOOKMARK_UPGRADE_NEW_BOOKMARK_LMIT }}
                </p>
              </div>
              <div class="rowFlex">
                <button class="alert-button-prime-2" (click)="Takemetoprime()">
                  <span class="upgrade">{{
                    constants.MONTHLY_SUBSCRIPTION
                    }}</span>
                </button>
                <a (click)="openInNewTab('/user')" class="redirect-bookmark">{{ constants.UNBOOKMARKING }}</a>
              </div>
            </div>
            <div class="prime-img-mobile-container prime-img-mobile-container-1">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.BOOKMARK_ALERT_IMG" alt="" />
              <a routerLink="['/user']" target="_blank" class="redirect-bookmark-mobile-bokmark">{{
                constants.UNBOOKMARKING }}
              </a>
            </div>
          </div>
          <div class="modal-body alert-body alert-Video-M0dal"
            *ngIf="alertSetter.bookmarkBeforeLogin && login && !isPrime">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title-new">
                {{ constants.AFTER_5_10_VIDEOS_TEXT1 }}
                <br />{{ constants.AFTER_5_10_VIDEOS_TEXT2 }}<br />
                {{ constants.AFTER_5_10_VIDEOS_TEXT3 }}
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img bookmark-alert-img-other" [src]="constants.AFTER_5_10_VIDEOS" alt="" />
              </div>
              <p class="alert-popup-content-prime-new-main">
                {{ constants.BOOKMARK_UPGRADE_NEW }}
              </p>
              <div class="text-align-center">
                <button class="alert-button">
                  <a (click)="Takemetoprime()">{{
                    constants.MONTHLY_SUBSCRIPTION
                    }}</a>
                </button>
              </div>
            </div>
            <div class="text-align-center bookmark-alert-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.AFTER_5_10_VIDEOS" alt="" />
            </div>
          </div>
          <div class="modal-body alert-body" *ngIf="alertSetter.bookmarkBeforeLogin && !login">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title">
                {{ constants.SIGNUP_TO_SAVE }}<br />
                {{ constants.FAVOURIATE_WINDOW }}
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img bookmark-alert-img-other" [src]="constants.BOOKMARK_ALERT_IMG" alt="" />
              </div>
              <p class="alert-popup-content">
                {{ constants.SIGNUP_IS_SIMPLE_TXT }}
              </p>
              <div class="text-align-center">
                <button class="alert-button" (click)="Takemetoprime()">
                  <a>{{ constants.SIGNUP_FOR_FREE_TXT }}</a>
                </button>
              </div>
            </div>
            <div class="text-align-center bookmark-alert-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.BOOKMARK_ALERT_IMG" alt="" />
            </div>
          </div>
          <div class="modal-body alert-body" *ngIf="alertSetter.upgradeToPrimeAd && !login">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title">
                <p style="margin-bottom: 0;">{{ constants.BOOKMARK_UPGRADE }}</p>
                <p style="font-weight: 600;margin-bottom: 0;">{{ constants.WINDOWS_ALL_ACCESS }}</p>
                <p style="margin-bottom: 0;">{{constants.FOR_SO_MUCH}}</p>
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img bookmark-alert-img-other" [src]="constants.AFTER_5_10_VIDEOS" alt="" />
              </div>
              <p class="alert-popup-content alert-1">
                {{ constants.UPGRADE_FOR_PLAYLIST_MAPS }}
              </p>
              <p class="alert-popup-content-prime-new-main-small">
                {{ constants.This_ADS_HELP }}
              </p>
              <div class="text-align-center">
                <button class="alert-button" (click)="TakemeTopricing()">
                  <a>{{ constants.UPGRADE_5_NEW }}</a>
                </button>
                <button class="alert-button-login" (click)="Takemetoprime()">
                  <a>{{constants.SIGNUP_FOR_FREE_TXT}}</a>
                </button>
              </div>
            </div>
            <div class="text-align-center bookmark-alert-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.AFTER_5_10_VIDEOS" alt="" />
            </div>
          </div>
          <div class="modal-body alert-body" *ngIf="alertSetter.locationBeforeLogin">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title">
                {{ constants.SIGNUP_TO_SEE }} <br />
                {{ constants.GOOGLEMAP_LOC }}
              </h3>
              <div class="text-align-center">
                <img class="location-alert-img bookmark-alert-img-other" [src]="constants.LOCATION_ALERT_IMG" alt="" />
              </div>
              <p class="alert-popup-content">
                {{ constants.SIGNUP_IS_SIMPLE_TXT }}
              </p>
              <div class="text-align-center">
                <button class="alert-button" (click)="Takemetoprime()">
                  <a>{{ constants.SIGNUP_FOR_FREE_TXT }}</a>
                </button>
              </div>
            </div>
            <div class="text-align-center bookmark-alert-img-mobile-container">
              <img class="bookmark-alert-img location-alert-img-mobile" [src]="constants.LOCATION_ALERT_IMG" alt="" />
            </div>
          </div>
          <div class="modal-body alert-body" *ngIf="alertSetter.submitBeforeLogin">
            <div class="text-align-center">
              <img class="submit-alert-img bookmark-alert-img-mobile" [src]="constants.POPUP_BEFORE_IMG" alt="" />
            </div>
            <div>
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title">
                {{ constants.SIGNUP_SHARE }}<br />
                {{ constants.WINDOWVIEWS }}
              </h3>
              <div class="text-align-center">
                <img class="submit-alert-img bookmark-alert-img-other" [src]="constants.POPUP_BEFORE_IMG" alt="" />
              </div>
              <p class="alert-popup-content">
                {{ constants.SUBMIT_ALERT_TXT }}
              </p>
              <div class="text-align-center">
                <button class="alert-button" (click)="Takemetoprime()">
                  <a>{{ constants.SIGNUP_FOR_FREE_TXT }} </a>
                </button>
              </div>
            </div>
          </div>

          <div class="modal-body alert-body" *ngIf="alertSetter.becomePrimeUser">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title-prime pb-2">
                {{ constants.FOLKS }}
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img-prime-folks bookmark-alert-img-other"
                  [src]="constants.PAYMENT_ALERT_IMG_NEW" alt="" />
              </div>
              <div class="new-div">
                <p class="alert-popup-content-prime-new">
                  {{ constants.WINDOWSWAP_ALL_ACCESS_UPDATED }}
                </p>
              </div>
              <div class="new-div-1">
                <p class="alert-content-small">
                  {{ constants.WINDOWSWAP_ALL_ACCESS_UPDATED }}
                </p>
              </div>
              <div class="rowFlex" style="margin-top: -10px">
                <button class="alert-button-prime-2" [routerLink]="['/pricing']">
                  <a class="upgrade">{{ constants.MONTHLY_SUBSCRIPTION }}</a>
                </button>
                <a (click)="onClickGoBack()" target="_blank" class="redirect-bookmark">{{ constants.BACK_TO_START }}
                </a>
              </div>
            </div>
            <div class="prime-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.PAYMENT_ALERT_IMG_NEW"
                alt="" />
              <a (click)="onClickGoBack()" target="_blank" class="redirect-bookmark-mobile">{{ constants.BACK_TO_START
                }}
              </a>
            </div>
          </div>

          <div class="modal-body alert-body-1" data-backdrop="static" *ngIf="alertSetter.NonPrimeUser">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title-nonprime">
                {{ constants.UNLOCK_WINDOW }} <br />{{
                constants.EVER_FEATURED
                }}
              </h3>
              <div class="text-center">
                <img class="bookmark-alert-img-prime-1 bookmark-alert-img-other" [src]="constants.BOOKMARK_ALERT_IMG"
                  alt="" />
              </div>
              <p class="alert-popup-content-nonprime">
                {{ constants.GET_WINDOWSWAP }}
              </p>
              <div class="rowFlex" style="margin-top: -10px">
                <button class="alert-button-prime alert-button-prime-1" (click)="Takemetoprime()">
                  <span class="upgrade">{{ constants.UPGRADE_5_TXT }}</span>
                </button>
              </div>
            </div>
            <div class="prime-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.BOOKMARK_ALERT_IMG" alt="" />
              <button class="alert-button-prime-mobile alert-button-prime-mobile-1" (click)="Takemetoprime()">
                <span class="upgrade">{{ constants.UPGRADE_5_TXT }}</span>
              </button>
            </div>
          </div>

          <div class="modal-body alert-body" *ngIf="alertSetter.playlistRestrict">
            <div class="bookmark-alert-content">
              <i class="material-icons alert-btn-close" (click)="showBookmarkAlert = false">{{ constants.CLOSE }}</i>
              <h3 class="alert-popup-title">
                {{ constants.UPGRADE_FOR_PLAYLIST }}<br />
                {{ constants.UPGRADE_FOR_PLAYLIST_1 }}
              </h3>
              <div class="text-align-center">
                <img class="bookmark-alert-img bookmark-alert-img-other margin-adjust"
                  [src]="constants.PLAYLIST_NO_ACCESS" alt="" />
              </div>
              <p class="alert-popup-content margin-adjust">
                {{ constants.UPGRADE_FOR_PLAYLIST_2 }}
              </p>
              <div class="text-align-center">
                <button class="alert-button" (click)="Takemetoprime()" *ngIf="!isPrime">
                  <a>{{ constants.GET_ALL_ACCESS_NOTMENU }}</a>
                </button>
              </div>
            </div>
            <div class="text-align-center bookmark-alert-img-mobile-container">
              <img class="bookmark-alert-img bookmark-alert-img-mobile" [src]="constants.PLAYLIST_NO_ACCESS" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ads-popup" id="ads-popup" *ngIf="showAds" (click)="hide()">
      <div class="ad-outer-div">
        <nav class="navbar-ads">
          <h1 class="heading-ad">{{ constants.THIS_KEEPS }}</h1>
          <i class="material-icons alert-btn-close-ad" (click)="showAds = false">{{ constants.CLOSE }}</i>
        </nav>
        <div class="ad-area">
          <iframe class="ads_screen" src="https://www.window-swap.com/ads.html" title="Iframe Example"></iframe>
        </div>
        <nav class="button-group">
          <button class="btn skip" (click)="onClickSkipAD()">
            {{ constants.REMOVE_AD }}
          </button>
          <a (click)="onClickSkipAD()" class="skip-mob">{{
            constants.REMOVE_AD
            }}</a>
        </nav>
        <div class="progress">
          <div class="progress-bar" role="progressbar" id="progress-bar" aria-valuenow="0" aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
      </div>
    </div>
    <div class="spinner_one" ngFor="let items of loader" *ngIf="
        tagSetter.InteriorsLoader ||
        tagSetter.CityLoader ||
        tagSetter.AnimalsLoader ||
        tagSetter.NightLoader ||
        tagSetter.SnowLoader ||
        tagSetter.RainLoader ||
        tagSetter.NatureLoader ||
        tagSetter.WaterLoader ||
        backtoallvideos ||
        emptyVideoList ||
        videoNotFound
      ">
      <div *ngIf="tagSetter.InteriorsLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.interiorloader_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.INTERIOR_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.CityLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.city_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.CITY_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.AnimalsLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.peties_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.PETS_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.NightLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.nighting_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.NIGHT_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.SnowLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.snowloader_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.SNOW_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.RainLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.ranies_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.RAIN_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.NatureLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.naturing_IMG" width="45px" class="jump" />
        <span class="enter_text">{{ constants.NATURE_PLAYLIST }}</span>
      </div>
      <div *ngIf="tagSetter.WaterLoader" class="d-flex justify-content-center align-items-center flex-column">
        <img [src]="constants.WATER_IMAGE" width="45px" class="jump" />
        <span class="enter_text">{{ constants.WATER_PLAYLIST }}</span>
      </div>
      <div *ngIf="backtoallvideos" class="d-flex justify-content-center align-items-center flex-column">
        <span class="enter_text"> {{ constants.BACK_TO_ALLWINDOW }}</span>
      </div>
      <div *ngIf="emptyVideoList" class="d-flex justify-content-center align-items-center flex-column">
        <span class="enter_text">
          {{ constants.NO_WINDOW }} <br />
          {{ constants.TRY_OTHER }}</span>
      </div>
      <div *ngIf="videoNotFound" class="d-flex justify-content-center align-items-center flex-column">
        <span class="enter_text">
          Oops, you've found a broken link! <br />
          Let us know at {{ emailAddress }}<br><br>
          <button class="copy-link" (click)="copyLinkToClipBoard()" [class.link-copied]="textCopied">
            <span *ngIf="!textCopied">{{constants.COPY_LINK_TXT}}</span>
            <span *ngIf="textCopied">{{constants.LINK_COPIED_TXT}}</span>
          </button></span>
      </div>
    </div>

    <div class="container container_1" id="container_1"
      *ngIf="from !== 'bookmarkedWindow' && !isMapsearchResult &&from !== 'cityVideos'">
      <img [src]="constants.updated_Glassy_IMG" class="filter_img_window" id="IMAGE_FILTER" (click)="opentagmodule()" />
      <div class="overlay" id="overlay_1">
        <img [src]="constants.Back_TAG_IMG" width="auto" class="window_tag_img" id="window_tag_img" alt="" />
        <div class="image-container" id="image-container">
          <div [ngClass]="{
              'tag-active': tagvalue === item.tagValue,
              'tag-inactive': tagvalue === 'all'
            }" class="hover-image" id="hover_I" (click)="filterVideos(item.tagValue)"
            *ngFor="let item of constants.PLAYLIST">
            <img src="{{ item.tagImgSrc }}" class="tag-hover" />
            <span class="caption text-center">{{ item.tagText }}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isMapsearchResult && from !== 'bookmarkedWindow' && from === 'cityVideos'" class="total_container"
      id="total_container">
      <img *ngIf="!mobiletagmodule" [src]="constants.updated_Glassy_IMG" class="filter_img_window_1" id="IMAGE_FILTER_1"
        (click)="openMobiletagmodule()" />
      <img *ngIf="mobiletagmodule" [src]="constants.updated_Glassy_IMG_1" class="filter_img_window_1"
        id="IMAGE_FILTER_1" (click)="closeTagmodule()" />
      <div class="my-container-2" id="my-container-2" [ngClass]="{
          closemodule: closemobiletagmodule,
          Openmodule: mobiletagmodule
        }" (click)="closemobiletag()">
        <img [src]="constants.Back_TAG_IMG" class="filter_img_window_2" alt="" />
        <div class="d-flex justify-content-space-between align-items-center mobile_content">
          <div [ngClass]="{ 'tag-active': tagvalue === item.tagValue }" class="hover-image"
            *ngFor="let item of constants.PLAYLIST">
            <img src="{{ item.tagImgSrc }}" class="tag-hover" (click)="filterVideos(item.tagValue)" />
            <span class="caption text-center">{{ item.tagText }}</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="
        !isMapsearchResult  && from !== 'bookmarkedWindow'
      " class="total_container_1" id="total_container_1">
      <img *ngIf="!mobiletagmodule" [src]="constants.updated_Glassy_IMG" class="filter_img_window_1_1"
        id="IMAGE_FILTER_2" (click)="openMobiletagmodule()" />
      <img *ngIf="mobiletagmodule" [src]="constants.updated_Glassy_IMG_1" class="filter_img_window_1_1"
        id="IMAGE_FILTER_2" (click)="closeTagmodule()" />
      <div class="my-container-2-2" [ngClass]="{
          closemodule: closemobiletagmodule,
          Openmodule: mobiletagmodule
        }" (click)="closemobiletag()">
        <img [src]="constants.Back_TAG_IMG" class="filter_img_window_2_2" width="auto" alt="" />
        <div class="d-flex justify-content-space-between align-items-center mobile_content_1">
          <div [ngClass]="{ 'tag-active': tagvalue === item.tagValue }" class="hover-image"
            *ngFor="let item of constants.PLAYLIST">
            <img src="{{ item.tagImgSrc }}" class="tag-hover" (click)="filterVideos(item.tagValue)" />
            <span class="caption text-center">{{ item.tagText }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile view hover effect -->
    <footer class="navbar sticky-bottom navbar-light bg-footer justify-content-between" id="footer">
      <div class="footer-item-1">
        <button *ngIf="!login" class="login-button footer-margin-right-small" placement="top" ngbTooltip=""
          [routerLink]="['/pricing']">
          {{constants.UPGRADE}}
        </button>
        <button *ngIf="!login && !isSmallMobile" class="submitWrapper-1 footer-margin-right" id="fwrapper"
          placement="top" ngbTooltip="Submit Window" (click)="toSignUp()" id="submitBtn" [ngClass]="{
            'hide-submit-mobile': login === false}" >
          <span class="sub-window"><img class="control-icon-fav-1" [src]="constants.SUBMIT_WINDOW_ICON1"/>&nbsp;&nbsp;Submit yours</span>
        </button>
        <button *ngIf="!isPrime && login" class="login-button footer-margin-right-small" placement="top" ngbTooltip=""
          [routerLink]="['/pricing']" [ngClass]="{
                    'footer-margin-right': from === 'bookmarkedWindow',
                    'footer-margin-right-small': from !== 'bookmarkedWindow'}" >
          {{constants.UPGRADE}}
        </button>
        <button *ngIf="isCampaign" class="shareWrapper footer-margin-right" id="swrapper">
          <app-sharepopup> </app-sharepopup>
        </button>
        <button [disabled]="isLoading"
         *ngIf="from === 'cityVideos' && login || from === 'bookmarkedWindow' && login"
          class="favoriteWrapper footer-margin-right" id="fwrapper" (click)="toggleFavorite()" placement="top"
          ngbTooltip="Bookmark">
          <img *ngIf="isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_ON_IMG" />
          <img *ngIf="isBookmark && !isLoading" class="control-icon-fav-mobile" [src]="constants.FAVORITE_ON_IMG_MOBILE" />
          <img *ngIf="!isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_OFF_IMG" />
          <img *ngIf="!isBookmark && !isLoading" class="control-icon-fav-mobile" [src]="constants.FAVORITE_OFF_IMG_MOBILE" />
          <button *ngIf="isLoading" class="loading-button control-icon-fav" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">{{ constants.LOADING_TEXT }}</span>
          </button>
          <button *ngIf="isLoading" class="loading-button control-icon-fav-mobile" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">{{ constants.LOADING_TEXT }}</span>
          </button>
        </button>
        <button *ngIf="from === 'window'  && login && !isSmallMobile " class="submitWrapper-1 footer-margin-right" id="fwrapper"
          placement="top" ngbTooltip="Submit Window" (click)="toSubmit()" [ngClass]="{
            'hide-submit-mobile': login && !isPrime }">
          <span class="sub-window"><img class="control-icon-fav-1" [src]="constants.SUBMIT_WINDOW_ICON1"/>&nbsp;&nbsp;Submit yours</span>
          <span class="sub-window-mobile">Submit</span>
        </button>
        
        <!-- <button *ngIf="from === 'bookmarkedWindow' && login" class="favoriteWrapper footer-margin-right" id="fwrapper"
          (click)="toggleFavorite()" placement="top" ngbTooltip="Bookmark">
          <img *ngIf="isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_ON_IMG" />
          <img *ngIf="!isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_OFF_IMG" />
          <button *ngIf="isLoading" class="loading-button" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">{{ constants.LOADING_TEXT }}</span>
          </button>
        </button> -->
        <!-- <button *ngIf="from === 'bookmarkedWindow' && !login" class="favoriteWrapper footer-margin-right" id="fwrapper"
          (click)="openWindowAlert('bookmarkBeforeLogin')" placement="top" ngbTooltip="Bookmark">
          <img class="control-icon-fav" [src]="constants.FAVORITE_OFF_IMG" />
        </button> -->
        <ng-container *ngTemplateOutlet="shareBookmarkTemplate"></ng-container>
        <button *ngIf="from === 'bookmarkedWindow'" class="shareWrapper footer-margin-right" id="swrapper'"
          placement="top" ngbTooltip="Share">
          <app-sharepopup> </app-sharepopup>
        </button>
        <button *ngIf="from === 'cityVideos'" class="shareWrapper footer-margin-right" id="swrapper'" placement="top"
          ngbTooltip="Share">
          <app-sharepopup> </app-sharepopup>
        </button>
        <button *ngIf="from === 'window'  && login && isSmallMobile" class="submitWrapper footer-margin-right" id="fwrapper"
          placement="top" ngbTooltip="Submit Window" [ngClass]="{
            'hide-submit-mobile': login && !isPrime }">
          <img class="control-icon-fav" [src]="constants.SUBMIT_WINDOW_ICON" (click)="toSubmit()" />
          <img class="control-icon-fav-mobile" [src]="constants.SUBMIT_WINDOW_ICON" (click)="toSubmit()" />
        </button>
      </div>
      <div class="footer-item-2">
        <button *ngIf="isPrime && from !== 'bookmarkedWindow'" class="pre-video-button" id="pre-video-button"
          [disabled]="disablePrevButton" (click)="onClickPrevious()" placement="top" ngbTooltip="Previous Window">
          <img class="control-icon-map" src="{{ constants.GOTO_PREV_IMG }}" alt="" />
          <img class="control-icon-map-mobile" src="{{ constants.GOTO_PREV_IMG_MOBILE }}" alt="" />
        </button>
        <button
          *ngIf="!isPrime && from !== 'bookmarkedWindow' || !isPrime && from !== 'window' || !isPrime && from !== 'cityVideos'"
          class="pre-video-button" style="visibility: hidden;" id="pre-video-button" [disabled]="disablePrevButton"
          placement="top" ngbTooltip="Previous Window">
          <img class="control-icon-map" src="{{ constants.GOTO_PREV_IMG }}" alt="" />
        </button>

        <button *ngIf="isPrime && from === 'bookmarkedWindow'" class="pre-video-button" id="pre-video-button"
          [disabled]="disablePrevButton" (click)="onClickPrevious()" placement="top" ngbTooltip="Previous Window">
          <img class="control-icon-map" src="{{ constants.GOTO_PREV_IMG }}" alt="" />
          <img class="control-icon-map-mobile" src="{{ constants.GOTO_PREV_IMG_MOBILE }}" alt="" />
        </button>

        <button *ngIf="from === 'window' && !isMapsearchResult" id="btn-window" data-backdrop="static"
          data-keyboard="false" (click)="handleClick()">
         {{ videoItem?.nextButtonText ? videoItem.nextButtonText : constants.OPEN_WINDOW_TXT }}
        </button>
        <button [disabled]="disableHandle" *ngIf="isMapsearchResult" id="btn-window" data-backdrop="static"
          data-keyboard="false" (click)="handleClick()">
          {{ constants.OPEN_A_WINDOW_TXT }}
        </button>
        <button *ngIf="from === 'cityVideos'" id="btn-window" data-backdrop="static" data-keyboard="false"
          (click)="handleClick()">
          {{ constants.OPEN_A_WINDOW_TXT }}
        </button>

        <button class="footer-margin-right footer-margin-left" *ngIf="isCampaign" id="btn-window-campaign"
          (click)="handleClick()">
          {{ constants.ANOTHER_WINDOW }}
        </button>
        <!-- (click)="windowClose()" -->
        <button *ngIf="from === 'bookmarkedWindow'" class="btn-window-close" (click)="handleClick()">
          Open the next bookmarked Window
        </button>
        <button *ngIf="from !== 'bookmarkedWindow'" class="map-search" (click)="onClickSearch()">
          <img placement="top" ngbTooltip="Search" class="control-icon-map" src="{{ constants.MAP_SEARCH }}"
            alt="map search" /><span class="tooltiptext">Search for a window!</span>
          <img placement="top" class="control-icon-map-mobile" src="{{ constants.MAP_SEARCH_MOBILE }}"
            alt="map search" />
        </button>

        <button *ngIf="from === 'bookmarkedWindow'" class="loopWrapper footer-margin-right" id="lwrapper"
          (click)="toggleShuffle()">
          <img *ngIf="!Shuffled" class="control-icon-loop-bookmarkedWindow" [src]="constants.BOOKMARK_SHUFFLE_OFF"
            placement="top" ngbTooltip="Shuffle off" />
          <img *ngIf="!Shuffled" class="control-icon-loop-bookmarkedWindow-mobile" [src]="constants.BOOKMARK_SHUFFLE_OFF_MOBILE"
            placement="top" ngbTooltip="Shuffle off" />
          <img *ngIf="Shuffled" class="control-icon-loop-bookmarkedWindow" [src]="constants.BOOKMARK_SHUFFLE_ON"
            placement="top" ngbTooltip="Shuffle on" />
          <img *ngIf="Shuffled" class="control-icon-loop-bookmarkedWindow-mobile" [src]="constants.BOOKMARK_SHUFFLE_ON_MOBILE"
            placement="top" ngbTooltip="Shuffle on" />
        </button>
      </div>
      <div class="footer-item-3">
        <button *ngIf="from === 'window'" class="loopWrapper footer-margin-right" id="lwrapper" (click)="toggleLoop()">
          <img *ngIf="!isLoop" class="control-icon-loop" [src]="constants.LOOP_BTN_IMG" placement="top"
            ngbTooltip="loop off" />
          <img *ngIf="!isLoop" class="control-icon-loop-mobile" [src]="constants.LOOP_BTN_IMG_MOBILE" placement="top"
            ngbTooltip="loop off" />
          <img *ngIf="isLoop" class="control-icon-loop" [src]="constants.SHUFFLE_IMG" placement="top"
            ngbTooltip="loop on" />
          <img *ngIf="isLoop" class="control-icon-loop-mobile" [src]="constants.SHUFFLE_IMG_MOBILE" placement="top"
            ngbTooltip="loop on" />
        </button>
        <button *ngIf="from === 'bookmarkedWindow'" class="loopWrapper footer-margin-right" id="lwrapper"
          (click)="toggleLoop()">
          <img *ngIf="!isLoop" class="control-icon-loop" [src]="constants.BOOKMARKED_LOOP" placement="top"
            ngbTooltip="loop off" />
          <img *ngIf="!isLoop" class="control-icon-loop-mobile" [src]="constants.LOOP_BTN_IMG_MOBILE" placement="top"
            ngbTooltip="loop off" />
          <img *ngIf="isLoop" class="control-icon-loop" [src]="constants.BOOKMARK_LOOP_OFF" placement="top"
            ngbTooltip="loop on" />
          <img *ngIf="isLoop" class="control-icon-loop-mobile" [src]="constants.SHUFFLE_IMG_MOBILE" placement="top"
            ngbTooltip="loop on" />
        </button>
        <button class="fullscreenWrapper footer-margin-right" (click)="zoomInzoomOut()"
          *ngIf="deviceInfo.device !== 'iPhone'">
          <img *ngIf="!checkValue" class="zoom-control-icon" [src]="constants.FULL_SCREEN_ICON" placement="top"
            ngbTooltip="Fullscreen" />
          <img *ngIf="!checkValue" class="zoom-control-icon-mobile" [src]="constants.FULL_SCREEN_ICON_MOBILE" placement="top"
            ngbTooltip="Fullscreen" />
          <img *ngIf="checkValue" class="zoom-control-icon" [src]="constants.FULL_SCREEN_ICON_OUT" placement="top"
            ngbTooltip="Exit Fullscreen" />
          <img *ngIf="checkValue" class="zoom-control-icon-mobile" [src]="constants.FULL_SCREEN_ICON_OUT_MOBILE" placement="top"
            ngbTooltip="Exit Fullscreen" />
        </button>
        <div class="volume-container" (mouseover)="showVolumSlider()" (mouseout)="hideVolumSlider()">
          <button *ngIf="from === 'window' || from === 'bookmarkedWindow' ||from === 'cityVideos'" class="volumeWrapper"
            id="vwrapper"  (click)="toggleVolume()">
            <img rel="preload" class="volume-control-icon"  [src]=" muted ? constants.VOLUME_OFF_IMG : constants.VOLUME_ON_IMG"/>
            <img rel="preload" class="volume-control-icon-mobile" [src]=" muted ? constants.VOLUME_OFF_IMG_MOBILE : constants.VOLUME_ON_IMG_MOBILE" />
          </button>
          <!-- <button *ngIf="from === 'bookmarkedWindow' ||from === 'cityVideos'" class="volumeWrapper" id="vwrapper"
            (click)="toggleVolume()">
            <img *ngIf="muted" class="volume-control-icon" [src]="constants.VOLUME_OFF_IMG" placement="top"
              ngbTooltip="   mute" />
            <img *ngIf="!muted" class="volume-control-icon" [src]="constants.VOLUME_ON_IMG" />
          </button> -->
          <button *ngIf="isCampaign" class="volumeWrapper" id="vwrapper" (click)="toggleVolume()">
            <img *ngIf="muted" rel="preload" class="volume-control-icon" [src]="constants.VOLUME_OFF_IMG" />
            <img *ngIf="!muted" rel="preload" class="volume-control-icon" [src]="constants.VOLUME_ON_IMG" />
          </button>
          <div class="slider-backdround" id="slider-backdround" (mouseover)="showVolumSlider()"
            (mouseout)="hideVolumSlider()">
            <input *ngIf="from === 'window' || from === 'bookmarkedWindow' ||from === 'cityVideos'" type="range" min="0"
              max="1" id="slider" step="0.01" (oninput)="SetVolume($event)" (change)="SetVolume($event)"
              value="{{ volume }}" />
          </div>
          <app-audio-player *ngIf="isCampaign"></app-audio-player>
        </div>
        <a href="https://www.instagram.com/velux/" target="_blank"><img *ngIf="isVelux" class="velux-logo"
            src="{{ constants.VELUX_LOGO_IMG }}" alt="" /></a>
      </div>
    </footer>

    <div [ngClass]="{
        'window-button-container': alertClose,
        'window-button-container-alert': !alertClose
      }" id="button-container"></div>
    <div *ngIf="from === 'window'" class="windowAlert" id="windowAlert">
      <a href="/CourtneyBarnett" class="alertText"><b>{{ constants.WINDOWSWAP_MUSIC }} </b>
        {{ constants.GLOBAL_COLLAB }}</a>
      <button (click)="closeAlert()" type="button" class="alertClose" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <app-custom-dialog (onCloseClick)="onPopupClose($event)" *ngIf="isCampaign" [title1]="
        campaignConstants.CAMPAIGN_TITLE1
          ? campaignConstants.CAMPAIGN_TITLE1
          : videoItem.title
      " [description]="
        campaignConstants.CAMPAIGN_DESCRIPTION
          ? campaignConstants.CAMPAIGN_DESCRIPTION
          : videoItem.description
      " [description2]="
        campaignConstants.CAMPAIGN_DESCRIPTION_TWO
          ? campaignConstants.CAMPAIGN_DESCRIPTION_TWO
          : videoItem.description2
      "></app-custom-dialog>
    <app-windowpopup *ngIf="(from === 'window' && !login) || ('bookmarkedWindow' && !login)"></app-windowpopup>
  </div>
</div>
<div id="winmaps"></div>
<ng-template #shareBookmarkTemplate>
  <button *ngIf="from === 'window'" class="shareWrapper footer-margin-right" id="swrapper'" placement="top"
    ngbTooltip="Share">
    <app-sharepopup> </app-sharepopup>
  </button>
  
  <button *ngIf="from === 'window' && !login" class="favoriteWrapper footer-margin-right" id="fwrapper"
    (click)="openWindowAlert('bookmarkBeforeLogin')" placement="top" ngbTooltip="Bookmark">
    <img class="control-icon-fav" [src]="constants.FAVORITE_OFF_IMG" />
    <img class="control-icon-fav-mobile" [src]="constants.FAVORITE_OFF_IMG_MOBILE" />
  </button>
  <button [disabled]="isLoading" *ngIf="from === 'window' && login" class="favoriteWrapper footer-margin-right"
    id="fwrapper" (click)="toggleFavorite()" placement="top" ngbTooltip="Bookmark">
    <img *ngIf="isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_ON_IMG" />
    <img *ngIf="isBookmark && !isLoading" class="control-icon-fav-mobile" [src]="constants.FAVORITE_ON_IMG_MOBILE" />
    <img *ngIf="!isBookmark && !isLoading" class="control-icon-fav" [src]="constants.FAVORITE_OFF_IMG" />
    <img *ngIf="!isBookmark && !isLoading" class="control-icon-fav-mobile" [src]="constants.FAVORITE_OFF_IMG_MOBILE" />
    <button *ngIf="isLoading" class="loading-button control-icon-fav" type="button" disabled>
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="sr-only">{{ constants.LOADING_TEXT }}</span>
    </button>
    <button *ngIf="isLoading" class="loading-button control-icon-fav-mobile" type="button" disabled>
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="sr-only">{{ constants.LOADING_TEXT }}</span>
    </button>
  </button>
</ng-template>
